export const GREETING_CONFIG_MAX_LENGTH = 200;

export function parseGreetingConfig(raw: unknown): { message: string; isFixedGreetingJson: boolean } {
  if (raw == null) {
    return { message: '', isFixedGreetingJson: false };
  }

  if (typeof raw === 'object') {
    const message = extractFixedGreetingMessage(raw);
    return message ? { message, isFixedGreetingJson: true } : { message: String(raw), isFixedGreetingJson: false };
  }

  const text = String(raw);
  const trimmed = text.trim();
  if (!trimmed) {
    return { message: '', isFixedGreetingJson: false };
  }

  try {
    const parsed = JSON.parse(trimmed);
    const message = extractFixedGreetingMessage(parsed);
    if (message) {
      return { message, isFixedGreetingJson: true };
    }
  } catch {}

  return { message: text, isFixedGreetingJson: false };
}

export function stringifyGreetingConfig(message: string): string {
  return JSON.stringify({
    type: 'Text',
    content: {
      text: {
        type: 'fixed_greeting',
        version: 1,
        message: String(message ?? '').trim()
      }
    }
  });
}

function extractFixedGreetingMessage(value: unknown): string | null {
  if (!value || typeof value !== 'object') return null;
  const data = value as Record<string, unknown>;

  if (data['type'] === 'fixed_greeting') {
    const message = data['message'];
    return typeof message === 'string' ? message : null;
  }

  if (data['type'] !== 'Text') return null;
  const content = data['content'];
  if (!content || typeof content !== 'object') return null;
  const text = (content as Record<string, unknown>)['text'];
  if (!text || typeof text !== 'object') return null;
  const greetingPayload = text as Record<string, unknown>;
  if (greetingPayload['type'] !== 'fixed_greeting') return null;
  const message = greetingPayload['message'];
  if (typeof message !== 'string') return null;
  return message;
}
